exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop-zone {\n  background-color: #f8f9fa;\n  border: 3px dashed #dee2e6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  -webkit-transition: 0.3s background-color ease;\n  transition: 0.3s background-color ease; }\n  .drop-zone > p {\n    margin-bottom: 0; }\n  .drop-zone:hover {\n    cursor: pointer; }\n  .drop-zone.has-file {\n    background-color: #bce5cc;\n    border-color: #43ac6a; }\n", ""]);

// exports
